import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "ah-cookie-consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-chalk border border-charcoal/15"
          data-testid="cookie-consent"
        >
          <div className="p-6">
            <p className="text-sm text-charcoal/80 font-light leading-relaxed">
              We use a small number of cookies to understand how the site is used. See our{" "}
              <Link to="/cookie-policy" className="link-underline text-charcoal">Cookie Policy</Link>.
            </p>
            <div className="mt-5 flex gap-3">
              <button
                onClick={() => decide("accepted")}
                className="flex-1 bg-charcoal text-chalk text-xs uppercase tracking-overline font-semibold py-3 hover:bg-bronze transition-colors duration-500"
                data-testid="cookie-accept"
              >
                Accept
              </button>
              <button
                onClick={() => decide("declined")}
                className="flex-1 border border-charcoal/30 text-charcoal text-xs uppercase tracking-overline font-semibold py-3 hover:bg-charcoal hover:text-chalk transition-colors duration-500"
                data-testid="cookie-decline"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
